import { useTranslation } from "react-i18next";

import BoyWithClipboard from "../../assets/boy-holding-clipboard.png";
import styles from "./smart-scheduling.module.scss";

export function SmartSchedulingBooked() {
  const { t } = useTranslation();

  return (
    <div className={styles.smartSchedulingBooked}>
      <img src={BoyWithClipboard} alt="Boy with clipboard" />
      <h1>{t("Your timeslots has been saved successfully")}</h1>
      <p>{t("We will send you an email with the details of your appointment if the appointment is confirmed")}</p>
      <p>{t("You can safely close this window now")}</p>
    </div>
  );
}
